const addketInputFields =[
    {
      name: "parentId",
      displayName: "Parent Id",
      type: "text",
      optional: false,
    },
    {
      name: "type",
      displayName: "Type",
      type: "dropdown",
      optional: false,
      options: [
        {
          value: "text",
          label: "Text",
        },
        {
          value: "radio",
          label: "Radio",
        },
        {
          value: "dropdown",
          label: "Dropdown",
        },
      ],
    },
    {
      name: "name",
      displayName: "Name",
      type: "text",
      optional: false,
    },
    {
      name: "displayComponent",
      displayName: "Display Conmponent",
      type: "text",
      optional: true,
    },
    {
      name: "configComponent",
      displayName: "Config Component",
      type: "text",
      optional: true,
    },
    {
      name: "className",
      displayName: "Class Name",
      type: "text",
      optional: true,
    },
    {
      name: "iconUrl",
      displayName: "Icon Url",
      type: "text",
      optional: true,
    },
    {
      name: "iconBgColor",
      displayName: "Icon Background Color",
      type: "text",
      optional: true,
    },
    {
      name: "displayname",
      displayName: "Display Name",
      type: "text",
      optional: false,
    },
    {
      name: "Record_Typ",
      displayName: "Record Type",
      type: "dropdown",
      optional: false,
      options: [
        {
          value: "node",
          label: "Node",
        },
        {
          value: "property",
          label: "Property",
        },
        {
          value: "field",
          label: "Field",
        },
      ],
    },
    {
      name: "teraFrSameAsValue",
      displayName: "Terraform Same Name Flag",
      type: "dropdown",
      optional: false,
      options: [
        {
          value: "Y",
          label: "Y",
        },
        {
          value: "N",
          label: "N",
        },
      ],
    },
    {
      name: "Active_Flg",
      displayName: "Active Flag",
      type: "dropdown",
      optional: false,
      options: [
        {
          value: "Y",
          label: "Y",
        },
        {
          value: "N",
          label: "N",
        },
      ],
    },
    {
      name: "usedInFE",
      displayName: "Used in Frontend",
      type: "dropdown",
      optional: false,
      options: [
        {
          value: "Y",
          label: "Y",
        },
        {
          value: "N",
          label: "N",
        },
      ],
    },
    {
      name: "RepoNm",
      displayName: "Key used in Repo Names",
      type: "text",
      optional: false,
    },
    {
      name: "Description",
      displayName: "Description",
      type: "text",
      optional: false,
    },
    {
      name: "DefaultValue",
      displayName: "Default Value",
      type: "text",
      optional: false,
    },
    {
      name: "c_id",
      displayName: "Catergory Id",
      type: "text",
      optional: true,
    },
    {
      name: "value",
      displayName: "Option Value",
      type: "text",
      optional: true,
    },
    {
      name: "label",
      displayName: "Option Label",
      type: "text",
      optional: true,
    },
    {
      name: "SortOrder",
      displayName: "Sort Order",
      type: "text",
      optional: false,
    },
    {
      name: "Terraform_Generated_Key",
      displayName: "Terraform Generated Key Flag",
      type: "dropdown",
      optional: false,
      options: [
        {
          value: "Y",
          label: "Y",
        },
        {
          value: "N",
          label: "N",
        },
      ],
    },
    {
      name: "Key_Location",
      displayName: "Key Location",
      type: "dropdown",
      optional: false,
      options: [
        {
          value: "keyvault",
          label: "Keyvault",
        },
        {
          value: "DB",
          label: "Database",
        },
        {
          value: "DB (ADMIN)",
          label: "Database (Admin)",
        },
      ],
    },
    {
      name: "Key_Vault_Type",
      displayName: "Key Vault Type",
      type: "dropdown",
      optional: false,
      options: [
        {
          value: "Client",
          label: "Client",
        },
        {
          value: "Common",
          label: "Common",
        },
      ],
    },
    {
      name: "Admin_Type",
      displayName: "Admin Type",
      type: "dropdown",
      optional: false,
      options: [
        {
          value: "Global",
          label: "Global",
        },
        {
          value: "Application",
          label: "Application",
        },
      ],
    },
  ];

  export default addketInputFields;